/**
 * Čas dne v minutách → `HH:mm`.
 *
 * Hodnoty z letového plánu už přicházejí normalizované (0–1439) i s posunem dne zvlášť — server je
 * počítá přes `Datum.AddMinutes`, protože legacy offsety běžně přetékají přes půlnoc a bývají
 * i záporné. Tahle funkce proto nic nemoduluje, jen formátuje.
 */
export function formatMinutes(minutes: number): string {
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  return `${String(hours).padStart(2, '0')}:${String(rest).padStart(2, '0')}`;
}

/** Posun dne jako značka `+1d` / `−1d`; 0 = bez značky. */
export function formatDayShift(shift: number): string | null {
  if (shift === 0) return null;
  return shift > 0 ? `+${shift}d` : `−${Math.abs(shift)}d`;
}

const WEEKDAY_FORMAT = new Intl.DateTimeFormat('cs-CZ', { weekday: 'short' });

/**
 * `DateOnly` ze serveru (`2026-08-07`) na lokální půlnoc.
 *
 * Přes `new Date(iso)` by se řetězec vzal jako UTC a v západních časových pásmech by datum ustřelilo
 * o den zpátky.
 */
function parseDateOnly(value: string): Date {
  const [year, month, day] = value.split('-').map(Number);
  return new Date(year, month - 1, day);
}

/** Popisek termínu v matici, po částech — den v týdnu a počet nocí se vykreslují ztlumeně. */
export interface TermLabelParts {
  start: string;
  startWeekday: string;
  end: string;
  nights: number;
}

/** `06.11. (pá) - 07.11.2026 (1 n.)` rozložené na části kvůli formátování. */
export function formatTermLabel(dateFrom: string, nights: number): TermLabelParts {
  const start = parseDateOnly(dateFrom);
  const end = new Date(start);
  end.setDate(end.getDate() + nights);

  const dayMonth = (date: Date) =>
    `${String(date.getDate()).padStart(2, '0')}.${String(date.getMonth() + 1).padStart(2, '0')}.`;

  return {
    start: dayMonth(start),
    startWeekday: WEEKDAY_FORMAT.format(start).replace('.', ''),
    end: `${dayMonth(end)}${end.getFullYear()}`,
    nights,
  };
}
